const doc = [({"en":({"travel":"Travel", "multiCity":"Multi city", "cruise":"Cruise"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;